"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getReadableDurations = void 0;

var _I18n = _interopRequireDefault(require("I18n"));

// stolen https://git.hubteam.com/HubSpot/MeetingsUI/blob/master/MeetingsAdmin/static/js/utils/utils.js
var getReadableDurations = function getReadableDurations(durations) {
  var sortedDurations = durations.sort(function (a, b) {
    return b - a;
  });

  var durationText = _I18n.default.formatList(sortedDurations.map(function (d) {
    var minutes = _I18n.default.moment.duration(d).minutes();

    if (minutes <= 60) {
      return _I18n.default.text('common.meetings.durations.minute', {
        count: _I18n.default.moment.duration(d).asMinutes()
      });
    }

    var hours = _I18n.default.moment.duration(d).hours();

    var hourText = _I18n.default.text('common.meetings.durations.hour', {
      count: hours
    });

    var minuteText = _I18n.default.text('common.meetings.durations.minute', {
      count: minutes
    });

    return _I18n.default.text('common.meetings.durations.combined', {
      hourText: hourText,
      minuteText: minuteText
    });
  }));

  return _I18n.default.text('common.meetings.placeholderName', {
    durations: durationText
  });
};

exports.getReadableDurations = getReadableDurations;